"use strict";

var windowDefined = typeof window !== "undefined";
var environment = windowDefined ? "browser" : "server";

module.exports = {
  environment: environment,
  isServer: environment === "server",
  isBrowser: environment === "browser"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/marty/dist/node/lib/environment.js
 ** module id = 460
 ** module chunks = 0
 **/